module.exports = __webpack_public_path__ + "img/three-icon.0d56e950.png";